MAX_FILE_SIZE = 10 * 1024 * 1024; /*10MB*/

class BESSAppProjectSupportingDocModal extends BESSAppModal {


    constructor(parent) {
        super('app-supporting-documentation-modal');
        this.parent = parent;
        this.isOpen = false;
        this.appRequirement = this.view.node.find('.app-requirement');
        this.appSelectDocumentSection = this.view.node.find('.app-select-document');
        this.appSelectDocumentInput = this.view.node.find('#id_existing_doc');
        this.appSelectDocumentInput.change(this.#updateState.bind(this));

        this.addDocTypeUploadSelect = this.view.node.find('#add-doc-type-upload');
        this.addDocTypePrintSelect = this.view.node.find('#add-doc-type-print');

        this.showIfPrintingView = this.view.node.find('.app-show-if-printing');
        this.showIfUploadingView = this.view.node.find('.app-show-if-uploading');

        this.addDocumentContents = this.view.node.find('.app-add-document-contents');
        this.dragDropZone = this.view.node.find('.app-upload-doc-file-dropzone');
        this.dragDropZone.on('dragover', function (e) {
            e.preventDefault();
            this.dragDropZone.addClass('drag-over');
        }.bind(this));
        this.dragDropZone.on('dragleave', function () {
            this.dragDropZone.removeClass('drag-over');
        }.bind(this));
        this.dragDropZone.on('drop', function (e) {
            e.preventDefault();
            this.dragDropZone.removeClass('drag-over');
            const files = e.originalEvent.dataTransfer.files;
            this.#handleDroppedFiles(files);
        }.bind(this));

        this.addDocNameSection = this.view.node.find('.app-add-doc-name');
        this.documentNameField = getMaterialTextControl('document_name', this.#updateState.bind(this));

        this.addDocTypeUploadSelect.change(this.#updateState.bind(this));
        this.addDocTypePrintSelect.change(this.#updateState.bind(this));

        this.selectFileInput = this.view.node.find('.app-select-file-input');
        this.selectFileInput.change(this.#onFileSelected.bind(this));
        /*this.uploadDocFile = this.view.node.find('#app-upload-doc-file');
        this.uploadDocFile.simpleUpload({
            dropZone: '.app-upload-doc-file-dropzone',
            progress: '.app-upload-doc-file-progress',
        });*/

        let dropZone = this.view.node.find('.app-upload-doc-file-dropzone');
        dropZone.on('dragenter', () => dropZone.addClass('drag-over'));
        dropZone.on('dragleave', () => dropZone.removeClass('drag-over'));
        this.dropZone = dropZone;
        this.dropZoneNoFile = this.dropZone.find('.app-no-file');
        this.dropZoneFile = this.dropZone.find('.app-file-selected');
        this.dropZone.find('.app-no-file a').bindClickEvent(this, this.#onSelectFile);
        this.dropZoneFile.find('a').bindClickEvent(this, this.#onClearFile);

        this.addDocButton = this.view.node.find('.app-add-document-btn');
        this.addDocButton.bindClickEvent(this, this.#onDone);

    }

    showFor(supportingDocItem) {
        this.file = null;
        this.isValid = false;
        this.supportingDocItem = supportingDocItem;
        this.isOpen = true;
        this.selectedDocument = supportingDocItem.selectedDocument;
        this.appSelectDocumentSection.hideIf(this.parent.documentLibrary.documents.length === 0);
        this.appRequirement.empty().append(supportingDocItem.requirementContent.clone());
        this.dropZone.removeClass('drag-over');

        this.appSelectDocumentInput.find('option').remove();
        this.#createDocumentOption('-1', 'Select existing Supporting Document...');

        this.forEach(this.parent.documentLibrary.documents, (doc) => this.#createDocumentOption(doc.docId, doc.selectText));

        if (this.supportingDocItem.selectedDocumentId != null) {
            this.appSelectDocumentInput.val(this.supportingDocItem.selectedDocumentId);
        }
        this.appSelectDocumentInput.enableIf(this.parent.documentLibrary.documents.length > (this.supportingDocItem.selectedDocumentId != null ? 1 : 0));

        this.addDocTypeUploadSelect.setCheckedIf(false);
        this.addDocTypePrintSelect.setCheckedIf(false);
        this.documentNameField.val('');

        this.#updateState(false);
        this.open();
    }

    #updateState(animated = true) {
        if (!this.isOpen) return;
        this.showIfUploadingView.showIf(this.addDocTypeUploadSelect.isChecked());
        this.showIfPrintingView.showIf(this.addDocTypePrintSelect.isChecked());
        this.addDocNameSection.showIf(this.addDocTypePrintSelect.isChecked() || this.addDocTypeUploadSelect.isChecked());
        this.docType = null;

        this.addDocumentContents.showAnimatedIf(this.addDocTypePrintSelect.isChecked() || this.addDocTypeUploadSelect.isChecked(), animated);

        if (this.addDocTypePrintSelect.isChecked()) {
            this.docType = BESSAppProjectDoc.PROJECT_DOCUMENT_TYPE_WILL_BE_PRINTED;
            this.docName = this.documentNameField.val();
        }

        if (this.addDocTypeUploadSelect.isChecked()) {
            this.docType = BESSAppProjectDoc.PROJECT_DOCUMENT_TYPE_UPLOADED;
            this.docName = this.documentNameField.val();
            this.isValid = this.docName.length > 3;
        }

        let selectedDocId = '' + this.appSelectDocumentInput.val();
        let documentSelected = selectedDocId !== "-1" && selectedDocId !== this.supportingDocItem.selectedDocumentId;

        this.isValid = this.documentNameField.val().length > 3 || documentSelected;

        this.addDocButton.enableIf(this.isValid);

        this.dropZoneNoFile.showIf(this.file === null);
        this.dropZoneFile.showIf(this.file !== null);
    }

    #onDone() {
        this.addDocButton.disableControl();
        this.addDocButton.addClass('app-saving');

        if (this.docType === null) {
            let selectedDocId = '' + this.appSelectDocumentInput.val();

            this.parent.api().changeSupportingDocument(this.supportingDocItem.docId, selectedDocId, this.#onDoneComplete.bind(this),);
        } else if (this.docType === BESSAppProjectDoc.PROJECT_DOCUMENT_TYPE_UPLOADED && this.file !== null) {

            this.parent.api().uploadSupportingDocument(this.supportingDocItem.docId, this.file, this.docName, this.#onDoneComplete.bind(this),);

        } else {

            this.parent.api().updateSupportingDocumentItem(this.supportingDocItem.docId, this.docType, this.docName, this.#onDoneComplete.bind(this),);
        }
    }

    #onDoneComplete(result) {
        let docId = '' + this.appSelectDocumentInput.val();
        let url = '';
        if (result != null) {
            if (result.changed) {
                this.parent.updateState(result.state);
            }
            docId = result.additional['doc_id'];
            url = nullIfUndefined(result.additional['doc_url']);
        }
        let document = _.find(this.parent.documentLibrary.documents, (x) => x.docId === docId);
        this.log("#onDoneComplete", document);

        this.supportingDocItem.updated(
            docId,
            document === undefined ?
                this.docName : document.docName,
            document === undefined ? this.docType : document.docType,
            this.isValid, url);

        this.addDocButton.enableControl();
        this.addDocButton.removeClass('app-saving');
        this.close();
    }

    #createDocumentOption(val, text) {
        let node = $('<option></option>');
        node.attr('value', val);
        node.text(text);
        this.appSelectDocumentInput.append(node);
    }

    #onSelectFile() {
        this.selectFileInput.click();
    }

    #onClearFile() {
        this.file = null;
        this.documentNameField.val('');
        this.selectFileInput.val('');
        this.#updateState(false);
    }

    #onFileSelected() {
        let files = this.selectFileInput.prop('files');
        if (files.length > 0) {
            if(this.#setFile(files[0])) {
                this.dropZoneFile.find('span').text(this.file.name);
                this.documentNameField.val(this.file.name);
                this.documentNameField.focus();
                this.#updateState(false);
            }
        }
    }

    #setFile(file) {
        if(file.size <= MAX_FILE_SIZE) {
            this.file = file;
            return true;
        } else {
            this.informUser("File too big!", "Maximum upload file size is 10MB.");
            return false;
        }
    }

    #handleDroppedFiles(files) {
        if (files.length > 0) {
            if(this.#setFile(files[0])) {
                this.dropZoneFile.find('span').text(this.file.name);
                this.documentNameField.val(this.file.name);
                this.documentNameField.focus();
            }
        }
        this.#updateState(false);
    }

}